import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app.store";
import {
  getProductAttributeGroupListApi,
  getProductAttributeListApi,
  getProductAttributeValueListApi,
} from "./product-attribute.api";
import {
  ProductAttributeGroupModel,
  ProductAttributeModel,
  ProductAttributeState,
  ProductAttributeValueModel,
} from "./product-attribute.models";

export const fetchProductAttributeList = createAsyncThunk(
  "product-attribute/fetchProductAttributeList",
  async (any, thunkApi) => {
    try {
      const res = await getProductAttributeListApi();
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);
export const fetchProductAttributeGroupList = createAsyncThunk(
  "product-attribute/fetchProductAttributeGroupList",
  async (any, thunkApi) => {
    try {
      const res = await getProductAttributeGroupListApi();
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);
export const fetchProductAttributeValueList = createAsyncThunk(
  "product-attribute/fetchProductAttributeValueList",
  async (any, thunkApi) => {
    try {
      const res = await getProductAttributeValueListApi();
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);
export const productAttributeSlice = createSlice({
  name: "productAttribute",
  initialState: {
    attributeGroups: [] as ProductAttributeGroupModel[],
    attributes: [] as ProductAttributeModel[],
    attributeValues: [] as ProductAttributeValueModel[],
  } as ProductAttributeState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchProductAttributeGroupList.fulfilled,
      (state, action) => {
        state.attributeGroups = action.payload;
      }
    );
    builder.addCase(fetchProductAttributeList.fulfilled, (state, action) => {
      state.attributes = action.payload;
    });
    builder.addCase(
      fetchProductAttributeValueList.fulfilled,
      (state, action) => {
        state.attributeValues = action.payload;
      }
    );
  },
});

export const productAttributeGroupsSelector = (state: RootState) =>
  state.productAttribute.attributeGroups;
export const productAttributesSelector = (state: RootState) =>
  state.productAttribute.attributes;
export const productAttributeValuesSelector = (state: RootState) =>
  state.productAttribute.attributeValues;
